import { useEffect, useState } from "react";

import { ManageCPFCal } from "../../_service";
import { Notify, Utils, calculateSDL, calculateCPFValues } from "../../utils";
import { useAppSelector } from "../../_app";
import {
  CustomButton,
  CustomDateField,
  CustomNumberField,
  CustomTextField,
} from "../../components";
import moment from "moment";

const AnnualBonusRow = (props: any) => {
  const { data,  onUpdate, isFinalized, onDelete } = props;

  const [edit, setEdit] = useState<boolean>(false);
  const [remove, setRemove] = useState<boolean>(false);
  
  const [bonusAmount, setBonusAmount] = useState<any>(
    data?.bonus_amount
  );

  const [numberOfBonusMonths, setNumberOfBonusMonths] = useState<any>(data?.no_of_bonus_months);

  const [sdl, setSdl] = useState<number>(data?.sdl ?? 0);
  const [cpfEmployee, setCpfEmployee] = useState<number>(data?.cpf_employee ?? 0);
  const [cpfEmployer, setCpfEmployer] = useState<number>(data?.cpf_employer ?? 0);
  const [cpfTotal, setCpfTotal] = useState<number>(data?.cpf_total ?? 0);

  const user = useAppSelector((state) => state.user);

  const toggle = () => setEdit((prev) => !prev);
  const toggleDelete = () => setRemove((prev) => !prev);


  //   const handleCpfTableDataUpdate = async () => {
  //     setUpdating(true);
  //     const formData = {
  //       effective_from: effectiveFrom,
  //       effective_to: effectiveTo,
  //       ow: maxOw,
  //       aw: maxAw,
  //     };
  //     if (parseInt(maxAw) > 102000) {
  //       Notify("Max AW can't be greater than 102000", 0);
  //       setUpdating(false);
  //     } else {
  //       const res = await ManageCPFCal._updateCpfLimitData(
  //         data?.id as string,
  //         formData
  //       );

  //       if (res.status === 200) {
  //         syncData();
  //         Notify("Data Updated Successfully", 1);
  //       } else {
  //         Notify("Data Updating Failed", 0);
  //       }
  //       setUpdating(false);
  //       setEdit(false);
  //     }
  //   };

  useEffect(() => {
    setBonusAmount(data?.bonus_amount);
    setNumberOfBonusMonths(data?.no_of_bonus_months);
    setSdl(data?.sdl ?? 0);
    setCpfEmployee(data?.cpf_employee ?? 0);
    setCpfEmployer(data?.cpf_employer ?? 0);
    setCpfTotal(data?.cpf_total ?? 0);
  }, [data?.bonus_amount, data?.no_of_bonus_months, data?.sdl, data?.cpf_employee, data?.cpf_employer, data?.cpf_total]);

  const onCancel = () => {
    toggle();
    setBonusAmount(data?.bonus_amount);
    setNumberOfBonusMonths(data?.no_of_bonus_months);
    setSdl(data?.sdl ?? 0);
    setCpfEmployee(data?.cpf_employee ?? 0);
    setCpfEmployer(data?.cpf_employer ?? 0);
    setCpfTotal(data?.cpf_total ?? 0);
  }

  // const calculateBonusMonths = (
  //   bonusAmount: string | number,
  //   salary: string
  // ) => {
  //   console.log('inside calc bonus month', bonusAmount, salary)
  //   let amount = parseFloat(`${bonusAmount}`);
  //   let basicSalary = parseFloat(`${salary}`?.replace(/,/g, "")) || 0.0;
  //   let bonusMonth = Number((amount / basicSalary).toFixed(2)) || 0.0;

  //   return bonusMonth;
  // };

  return (
    <tr>
      {edit ? (
        <>
          <td>{data?.employee_name}</td>
          <td style={{ paddingLeft : "1rem" }}>{data?.salary_type}</td>
          <td>{moment(data?.date_joined).format("DD-MM-YYYY")}</td>
          <td>{data?.resigned_date ? moment(data?.resigned_date).format("DD-MM-YYYY") : ''}</td>
          <td>{data?.employee}</td>
          <td style={{ textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(
              `${data?.basic_salary}`?.replace(/,/g, "")
            )}
          </td>
          <td style={{ textAlign: "right" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "90%",
                marginLeft: "auto",
                alignItems: 'center'
              }}
            >
              <CustomNumberField value={bonusAmount} onChangeText={(value)=>{
                setBonusAmount(value);
                const newBonusAmt = parseFloat(value) || 0;
                const ow = parseFloat(`${data?.basic_salary}`?.replace(/,/g, "")) || 0;
                const newBonusMonths = Number(isFinite(newBonusAmt / ow) ? newBonusAmt / ow : 0).toFixed(2);
                setNumberOfBonusMonths(newBonusMonths);

                const newSdl = calculateSDL(ow, newBonusAmt, data?.sdl_data || []);
                const cpf = calculateCPFValues(ow, newBonusAmt, data?.cpf_calculator_data || []);
                setSdl(newSdl);
                setCpfEmployee(cpf.cpfEmployee);
                setCpfEmployer(cpf.cpfEmployer);
                setCpfTotal(cpf.cpfTotal);
              }} inputWidth={'100%'}   />
            </div>
          </td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(cpfEmployee)}</td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(cpfEmployer)}</td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(cpfTotal)}</td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(sdl)}</td>
          <td style={{ textAlign: "right" }}>
          <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "40%",
                marginLeft: "auto",
                alignItems: 'center'
              }}
            >
              {numberOfBonusMonths}
            </div>
          </td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.25rem",
              }}
            >
              <p
                style={{
                  padding: "0.25rem 0.75rem",
                  background: "#059BBF",
                  cursor: "pointer",
                  color: "white",
                  fontWeight: 400,
                  borderRadius: "0.5rem",
                }}
                onClick={()=>{
                  onUpdate(data?.employee, bonusAmount, numberOfBonusMonths, sdl, cpfEmployee, cpfEmployer, cpfTotal);
                  toggle();
                }}
              >
                {"Update"}
              </p>
              <img
                onClick={onCancel}
                alt="cancel"
                title="Cancel"
                style={{ width: "2rem", cursor: "pointer" }}
                src="/cancel.svg"
              />
            </div>
          </td>
        </>
      ) : (
        <>
          <td>{data?.employee_name}</td>
          <td style={{ paddingLeft : "1rem" }}>{data?.salary_type}</td>
          <td>{moment(data?.date_joined).format("DD-MM-YYYY")}</td>
          <td>{data?.resigned_date ? moment(data?.resigned_date).format("DD-MM-YYYY") : ''}</td>
          <td>{data?.employee}</td>
          <td style={{ textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(
              `${data?.basic_salary}`?.replace(/,/g, "")
            )}
          </td>
          <td style={{ textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(
              `${data?.bonus_amount}`.replace(/,/g, "")
              )}
          </td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(data?.cpf_employee || 0)}</td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(data?.cpf_employer || 0)}</td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(data?.cpf_total || 0)}</td>
          <td style={{ textAlign: "right" }}>{Utils.getCommanSepartedNumericStringWithDollar(data?.sdl || 0)}</td>
          <td style={{ textAlign: "right" }}>{(parseFloat(data?.no_of_bonus_months || 0)).toFixed(2)}</td>
          {!isFinalized && <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
              }}
              >
              {
                  remove ? (
                    <>
                      <p
                        style={{
                          padding: "0.25rem 0.75rem",
                          background: "#ff6665",
                          cursor: "pointer",
                          color: "white",
                          fontWeight: 400,
                          borderRadius: "0.25rem",
                        }}
                        onClick={() => {
                          onDelete(data?.employee)
                          toggleDelete()
                        }}
                      >
                        {"Confirm"}
                      </p>
                      <img
                        onClick={toggleDelete}
                        alt="cancel"
                        title="Cancel"
                        style={{ width: "2rem", cursor: "pointer" }}
                        src="/cancel.svg"
                      />
                    </>
                  ): (
                    <p
                      style={{
                        padding: "0.25rem 0.75rem",
                        background: "#ff6665",
                        cursor: "pointer",
                        color: "white",
                        fontWeight: 400,
                        borderRadius: "0.25rem",
                      }}
                      onClick={toggleDelete}
                    >
                      {"Delete"}
                    </p>
                  )
               }
              {!remove && (<p
                style={{
                  padding: "0.25rem 0.75rem",
                  background: "#059BBF",
                  cursor: "pointer",
                  color: "white",
                  fontWeight: 400,
                  borderRadius: "0.25rem",
                }}
                onClick={toggle}
              >
                {"Edit"}
              </p>)}
            </div>
          </td>}
        </>
      )}
    </tr>
  );
};

export default AnnualBonusRow;
